// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1-1ak","saveButton":"style_saveButton__3QwBl","registerHeader":"style_registerHeader__3llgE","addressTitle":"style_addressTitle__1Zpm6"};